export const CREATE_ORDERSUGGESTION71819 = "CREATE_ORDERSUGGESTION71819";
export const UPDATE_ORDERSUGGESTION71819 = "UPDATE_ORDERSUGGESTION71819";
export const DELETE_ORDERSUGGESTION71819 = "DELETE_ORDERSUGGESTION71819";
export const FETCH_ORDERSUGGESTION71819 = "FETCH_ORDERSUGGESTION71819";
export const LISTEN_TO_SELECTED_ORDERSUGGESTION71819 =
  "LISTEN_TO_SELECTED_ORDERSUGGESTION71819";
export const FILTER_ORDERSUGGESTION71819 = "FILTER_ORDERSUGGESTION71819";
